import React from 'react'
import { MultiSelect, MultiSelectProps } from '@mantine/core'
import { color } from 'src/variable/constant'

function CustomMultiSelect({
	sx,
	...props
}: MultiSelectProps & React.RefAttributes<HTMLInputElement>) {
	return (
		<MultiSelect
			sx={{
				minWidth: 240,
				minHeight: 36,
				input: {
					':focus': {
						borderColor: color.CmsPrimary,
					},
				},
				'.mantine-MultiSelect-item': {
					'&[data-selected]': {
						backgroundColor: color.CmsPrimary,
						'&:hover': {
							backgroundColor: color.CmsPrimary,
						},
					},
				},
				...sx,
			}}
			{...props}
		/>
	)
}

export default React.memo(CustomMultiSelect)
